
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 18,
    height: 23,
    viewBox: '0 0 18 23',
    data: '<path pid="0" d="M16.3 23H1.8c-1 0-1.7-.8-1.8-1.7V1.8C0 .8.8 0 1.7 0h7.7c.4 0 .9.2 1.2.5l6.9 7c.3.3.5.7.5 1.2v12.6c.1.9-.6 1.7-1.5 1.8l-.2-.1zm0-1.5c.1 0 .2-.1.2-.2V8.5l-6.9-7H1.8c-.1 0-.3.1-.3.3v19.5c0 .1.1.3.3.3h14.5z"/>'
  }
})
